<div class="canvas">
  <div class="pictogram">
    <div class="icon">
      <i2g-icon [icon]="onboardingIcon"></i2g-icon>
    </div>
  </div>

  <p class="heading">
    {{ 'DIALOG.PAYMENTS.I2G_MONEY.WELCOME.TITLE' | translate }}
  </p>

  <!-- Zero Fees -->
  <p class="benefit-title">
    {{ 'DIALOG.PAYMENTS.I2G_MONEY.WELCOME.BENEFIT_TITLE_1' | translate }}
  </p>
  <p class="benefit-description">
    {{ 'DIALOG.PAYMENTS.I2G_MONEY.WELCOME.BENEFIT_DESCRIPTION_1' | translate }}
  </p>

  <!-- Convenient -->
  <p class="benefit-title">
    {{ 'DIALOG.PAYMENTS.I2G_MONEY.WELCOME.BENEFIT_TITLE_2' | translate }}
  </p>
  <p class="benefit-description">
    {{ 'DIALOG.PAYMENTS.I2G_MONEY.WELCOME.BENEFIT_DESCRIPTION_2' | translate }}
  </p>

  <!-- Less admin -->
  <p class="benefit-title">
    {{ 'DIALOG.PAYMENTS.I2G_MONEY.WELCOME.BENEFIT_TITLE_3' | translate }}
  </p>
  <p class="benefit-description">
    {{ 'DIALOG.PAYMENTS.I2G_MONEY.WELCOME.BENEFIT_DESCRIPTION_3' | translate }}
  </p>

  <a
    href="https://invoice.2go.com"
    target="_blank"
    i2gButton
    buttonStyle="tertiary"
    class="learn-more"
    (click)="learnMore()"
  >
    <span class="pull-left">
      {{ 'DIALOG.PAYMENTS.I2G_MONEY.WELCOME.LEARN_MORE' | translate }}
    </span>
  </a>
</div>

<div class="cta">
  <hr class="separator" />

  <button
    class="apply-button"
    i2gButton
    buttonStyle="emphasis"
    (click)="setupNow()"
  >
    {{ 'DIALOG.PAYMENTS.I2G_MONEY.WELCOME.SETUP' | translate }}
  </button>

  <p class="disclosure">
    {{ 'DIALOG.PAYMENTS.I2G_MONEY.WELCOME.DISCLOSURE' | translate }}
  </p>
</div>
